<template>

    <p class="text-headline-small">Geometria</p>

    <p class="text-left">
        <strong>Fornendo una geometria, la geometria precedente verrà sostituita.</strong><br>
        I formati file supportati sono: <br>
    </p>
    <ul class="pl-6">
        <li>GeoJSON </li>
        <li>GPX </li>
    </ul>
    I tipi di geometria supportati sono:
    <ul class="pl-6">

        <li v-for="(k, v) in props.accepting">
            <v-icon color="grey">
                mdi-{{ geometriesIcons[k] }}
            </v-icon>
            {{ geometriesTranslations[k] }} ({{ k }})
        </li>
    </ul>
    <p class="text-left">
        Nota bene: <br>
        Il sistema di riferimento accettato è EPSG:4326.<br>
        Se il file contiene più geometrie, viene utilizzata <span class="text-decoration-underline">la prima compatibile</span>.<br>
        Il MultiLineString viene convertito in LineString (collegando secondo ordinamento).<br>
        <br>
    </p>

    <file-input class="d-flex" :config="fileuploadconfig" @onFileReaded="onFileReaded" /><br>

</template>

<script setup>

import { ref, computed, onMounted } from 'vue'
import { gpx } from "@tmcw/togeojson";

import { useToastsStore } from '@/store/toasts';

import FileInput from '@/components/media/FileInput.vue'

const geometryData = defineModel()


const props = defineProps({
    "accepting": {
        type: Array,
        default: [],
        required: true
    }
})

const toastsStore = useToastsStore()

const geometriesTranslations = {
    "Point": "Punto",
    "LineString": "Linea",
    "MultiLineString": "Linee scollegate",
    "Polygon": "Poligono"
}

const geometriesIcons = {
    "Point": "vector-point",
    "LineString": "vector-polyline",
    "MultiLineString": "vector-polyline-plus",
    "Polygon": "vector-square"
}

const fileuploadconfig = {
    destination: "consume",
    icon: "mdi-swap-vertical-bold",
    label: "sostituisci",
    size: "large",
    file: {
        // geojson: true,
        // gpx: true,
        everything: true,
    },
}

const onFileReaded = (the_file) => {
    // console.log("filePassed")
    // console.log(the_file)
    // console.log(the_file)

    let content = null

    console.log(the_file)

    if (["geojson", "json"].includes(the_file.extension) ) {  // geojson, json, but => geo.json? 
        // if (the_file.mimetype === "application/geo+json") {
            content = JSON.parse(the_file.content)
        }
        
    if (the_file.extension === "gpx" ) {
    // if (the_file.mimetype === "application/gpx+xml") {  // android non legge questo mimetype
        const content_gpx = new DOMParser().parseFromString(the_file.content, "text/xml")
        content = gpx(content_gpx)
    }

    if (!content?.features) {
        console.error("no features found")
        return
    }


    let choosenGeometry = null

    // debugger
    
    for (const feature of content.features) {

        const geometry = feature?.geometry

        parseGeometry(geometry)

        if (props.accepting.indexOf(geometry?.type) > -1) {
            choosenGeometry = geometry
            break
        }
        else {
            console.error("geometry not compatible")
        }
    }

    if (choosenGeometry === null) {
        // debugger

        console.error("no geometry found")

        toastsStore.toast({
            title: `Geometria`,
            text: `Geometria non compatibile
                        ${choosenGeometry?.type} 
                        non è tra le geometrie accettate: 
                        ${props.accepting.join(", ")}
                    .`,
            type: "error",
        })
        return

    }

    // generate meta here if needed

    const meta = {
    }


    geometryData.value = {
        geometry: choosenGeometry,          // choosenGeometry
        // completeGeoJSON: content,          // complete geojson, receiver should take geometry provided above
        meta: meta                    // start, end, dates, etc
    }


    toastsStore.toast({
        title: `Geometria`,
        text: `Geometria modificata.`,
        type: "info",
    })

}


const parseGeometry = (geometry) => {

    // clean geometry from z or m values, see:
    // xy
    // xyz
    // xyzm

    if (geometry?.type === "Point") {
        geometry.coordinates = [geometry.coordinates[0], geometry.coordinates[1]]
    }

    if (geometry?.type === "LineString") {
        geometry.coordinates = geometry.coordinates.map((c) => [c[0], c[1]])
    }
    
    // New MultiLineString case: flattens nested lines into one LineString
    if (geometry.type === "MultiLineString") {
        const flattened = geometry.coordinates.flat();
        geometry.coordinates = flattened.map((c) => [c[0], c[1]]);
        geometry.type = "LineString";
    }


    if (geometry?.type === "Polygon") {
        geometry.coordinates = geometry.coordinates.map((c) => c.map((cc) => [cc[0], cc[1]]))
    }
}


onMounted(() => {
})

</script>
